/* eslint-disable react/function-component-definition */
import React, { useEffect, useState } from 'react';
import { AccordionStyle } from './styles';
import { ReactComponent as IconMenu } from '../../assets/icons/iconExpandArrow.svg';
import { Button } from '../Buttons/Button';

interface AccordionProps {
  children: React.ReactNode;
  title: React.ReactNode;
  subtitle?: string;
  type?: 'menu' | 'default';
  isOpen?: boolean;
  activeButton?: boolean;
  onOpen?: () => void;
  onCallback?: () => void;
}

export const Accordion: React.FC<AccordionProps> = ({
  activeButton,
  isOpen = false,
  children,
  title,
  subtitle,
  type,
  onOpen,
  onCallback,
}) => {
  const [active, setActive] = useState(false);

  function handleOpenAccordion() {
    setActive(type === 'menu' ? true : !active);
  }

  useEffect(() => {
    if (active) {
      onOpen?.();
    }
  }, [active, onOpen]);

  useEffect(() => {
    setActive(isOpen);
  }, [isOpen]);

  return (
    <AccordionStyle
      menuOpen={active}
      onMouseLeave={
        type === 'menu'
          ? () => {
              if (!isOpen) setActive(false);
            }
          : () => {}
      }
      type={type}>
      <div className="headerAccordion">
        <div
          className="contentHeader"
          onMouseEnter={
            type === 'menu'
              ? () => {
                  handleOpenAccordion();
                }
              : () => {}
          }>
          <div className="contentTitle">
            <button type="button" className="accordionTitle" onClick={handleOpenAccordion}>
              {title}
            </button>
            {type === 'menu' && <IconMenu />}
            {active && <p>{subtitle}</p>}
          </div>
          {active && activeButton && (
            <Button
              text="Marcar/Desmarcar todas"
              background="transparent"
              color="primary"
              textHoverColor="tertiary_500"
              font={{ size: 16, weight: 500 }}
              onClick={onCallback}
            />
          )}
        </div>
      </div>
      {active && <div className="content">{children}</div>}
    </AccordionStyle>
  );
};
